import React, { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import BrioRciMassage from '@assets/images/brio-rci-massage.jpg';
import BrioRciCrown from '@assets/images/rci-gold-crown.png';
import BrioRci from '@assets/images/brio-rci.svg';

import './style.scss';

export class BrioRciHowTo extends Component {
  render(): React.ReactNode {
    return (
      <div className="brio-rci-how-to">
        <section className="image-bg overlay parallax pt-xs-40 pb-xs-40">
          <div className="background-image-holder" style={{ backgroundImage: `url(${BrioRciMassage})` }}>
            <img alt="image" className="background-image" src={BrioRciMassage} />
          </div>
          <div className="container">
            <div className="row mb-xs-24">
              <div className="col-md-12 col-md-offset-3 col-sm-10 col-sm-offset-1 mb16 text-center">
                <img src={BrioRci} style={{ maxWidth: '300px' }} />
              </div>
            </div>
            <div className="row mb-xs-24" style={{ padding: '10px' }}>
              <h4 className="lead text-center mb0 secondary-font"><FormattedMessage id={'brio.rci.main.message'} /></h4>
            </div>
          </div>
        </section>
        <section className="pt-xs-32 pb-xs-24 pt32">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 hidden-md text-center mb32">
                <img className="" src={BrioRciCrown} style={{ width: '70%' }} />
              </div>
              <div className="col-lg-8 divider">
                <p className="h4">
                  <FormattedMessage id={'brio.rci.message.1'} />
                </p>
                <p className="h4">
                  <FormattedMessage id={'brio.rci.message.2'} />
                </p>
                <p className="h4">
                  <FormattedMessage id={'brio.rci.message.3'} />
                </p>
                <p className="h4">
                  <FormattedMessage id={'brio.rci.message.4'} />
                </p>
              </div>
            </div>
          </div>

        </section>
      </div>
    );
  }
}
